import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description
 * Maps an input color and those similar to the input color to corresponding shades of a specified output color, taking luminosity and chroma into account, in order to recolor objects in your image in a natural way.</br>
 * More highly saturated input colors usually give the best results. It is recommended to avoid input colors approaching white, black, or gray.</br>
 *
 * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#replace_color_effect|Replace color examples}
 * @memberOf Actions.Adjust
 */

var ReplaceColorAction = /*#__PURE__*/function (_Action) {
  _inherits(ReplaceColorAction, _Action);

  var _super = _createSuper(ReplaceColorAction);

  /**
   * @description Sets the target output color.
   * @param {string} toColor - The HTML name or RGB/A hex code of the target output color.
   */
  function ReplaceColorAction(toColor) {
    var _this;

    _classCallCheck(this, ReplaceColorAction);

    _this = _super.call(this);
    _this.targetColor = toColor;
    return _this;
  }
  /**
   * @description Sets the tolerance threshold.
   * @param {number} toleranceLevel - The tolerance threshold (a radius in the LAB color space) from the input color, </br>
   *                                  representing the span of colors that should be replaced with a correspondingly adjusted version of the target output color. </br>
   *                                  Larger values result in replacing more colors within the image. </br>
   *                                  The more saturated the original input color, the more a change in value will impact the result (Server default: 50).
   * @return {this}
   */


  _createClass(ReplaceColorAction, [{
    key: "tolerance",
    value: function tolerance(toleranceLevel) {
      this.toleranceLevel = toleranceLevel;
      return this;
    }
    /**
     * @description Sets the base input color to map.
     * @param {string} baseColor - The HTML name or RGB/A hex code of the base input color to map (Server default: the most prominent high-saturation color in the image).
     * @return {this}
     */

  }, {
    key: "fromColor",
    value: function fromColor(baseColor) {
      this.baseColor = baseColor;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      // Target color and base color might not exist at this point (optional qualifiers)
      // If they exist, ensure that any # for RGB are removed from the resulting string
      var targetColor = this.targetColor && this.targetColor.toString().replace('#', '');
      var baseColor = this.baseColor && this.baseColor.toString().replace('#', '');
      var qualifierValue = new QualifierValue(['replace_color', targetColor, this.toleranceLevel, baseColor]);
      this.addQualifier(new Qualifier('e', qualifierValue));
      return this;
    }
  }]);

  return ReplaceColorAction;
}(Action);

export { ReplaceColorAction };